import React, {useState} from 'react';
import ModalContainer from "../../common/modal_container";
import GameList from "../../list/game_list";
import {exportNewSlotJson} from "../../../data/gameData_slot";

export default function SlotModal({popShow, setPopShow}: {popShow: boolean; setPopShow: Function;}){
    return (
        <ModalContainer show={popShow}
                        setShow={setPopShow}
                        closeBtn={true}
                        className={'slot-popup'}
        >
            <GameList title={'SLOT MACHINE'} type={'slot'} list={exportNewSlotJson as []}/>
        </ModalContainer>
    )
}